import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,

    "BannerDiv": styled.div`
        position: relative;
        height: 216px;
    `,
    "BannerElem": styled.div`
        height: 216px;
    `,
    "BackgroundImg": styled.img`
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center; 
        cursor: pointer;
    `,
    "BackBtn": styled.button`
        position: absolute;
        top: 24px;
        left: 20px;
        width: 20px;
        height: 20px;
    `,
    "PageDiv": styled.div`
        position: absolute;
        right: 24px;
        bottom: 12px;
        width: fit-content;
        background-color: #2A2929;
        border-radius: 9999px;
        padding: 4px 8px;

        & > p {
            display: flex;
            gap: 4px;
            ${({ theme }) => theme.font["tiny-semibold"]};
            color: ${({ theme }) => theme.color["white"]};

            span {
                ${({ theme }) => theme.font["tiny-regular"]};
                color: ${({ theme }) => theme.color["white"]};
            }
        }
    `,
}